var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileiconFff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00046 13.25C4.22455 13.25 1 13.8209 1 16.1073C1 18.3937 4.20409 18.985 8.00046 18.985C11.7764 18.985 15 18.4132 15 16.1277C15 13.8423 11.7968 13.25 8.00046 13.25Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00049 9.98913C10.4784 9.98913 12.4868 7.97983 12.4868 5.50191C12.4868 3.02399 10.4784 1.01562 8.00049 1.01562C5.52257 1.01562 3.51327 3.02399 3.51327 5.50191C3.5049 7.97146 5.50025 9.98076 7.96887 9.98913H8.00049Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileiconFff);
export default __webpack_public_path__ + "static/media/profileiconFFF.6a045ead0509192665c43f296f49496a.svg";
export { ForwardRef as ReactComponent };